import React, { useEffect, useState } from "react";
import "./SignUp.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebookSquare } from "@fortawesome/free-brands-svg-icons";
import { Link, useNavigate } from "react-router-dom";
import { register } from "../../redux/actions/userActions";
import { useDispatch, useSelector } from "react-redux";
import Message from "../../Message/Message";

const SignUp = () => {
  const facebook = <FontAwesomeIcon icon={faFacebookSquare} />;
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const navigate = useNavigate();

  const dispatch = useDispatch();

  const redirect = window.location.search
    ? window.location.search.split("=")[1]
    : "/";

  const userRegister = useSelector((state) => state.userRegister);
  const { userInfo } = userRegister;

  useEffect(() => {
    if (userInfo) {
      navigate(redirect);
    }
  }, [userInfo, redirect, navigate]);

  const handleSignUp = (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      setMessage("Passwords do not match");
    } else {
      dispatch(register(name, phone, email, password));
      navigate('/login')
    }
  };

  return (
    <>
      <div className="signup">
        <div className="container h-100 text-white d-flex align-items-center justify-content-center">
          <div className="text-center w30">
            <div className="d-flex justify-content-center mb-3">
              <Link to='/'>
                <img className="cursor" src={require("../../../Asset/main logo.png")} alt="" />
              </Link>
            </div>
            <button className="fb-btn text-white mb-3">
              {facebook}&nbsp; Sign Up with Facebook
            </button>
            <h4 className="my-4">OR</h4>
            {message && <Message>{message}</Message>}
            <form onSubmit={handleSignUp}>
              <input onChange={(e) => setName(e.target.value)} className="form-control form-control-lg mb-3" type="text" placeholder="Name" />
              <input onChange={(e) => setEmail(e.target.value)} className="form-control form-control-lg mb-3" type="email" placeholder="Email" />
              <input onChange={(e) => setPhone(e.target.value)} className="form-control form-control-lg mb-3" type="number" placeholder="Phone Number" />
              <input onChange={(e) => setPassword(e.target.value)} className="form-control form-control-lg mb-3" type="password" placeholder="Password" />
              <input onChange={(e) => setConfirmPassword(e.target.value)} className="form-control form-control-lg mb-3" type="password" placeholder="Confirm Password" />

              <div class="mb-3 form-check">
                <input type="checkbox" class="form-check-input" id="exampleCheck1" />
                <label class="form-check-label" for="exampleCheck1">By registering, you agree to our Terms of Service and Terms
                  of Service and Privacy Policy.</label>
              </div>

              <button type="submit" className="signup-btn mb-3 text-white">SignUp</button>

              <div className="d-flex justify-content-center mb-3">
                Already a Member ?
                <Link className="ms-2 cl-pm" to="/login">
                  Sign In
                </Link>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default SignUp;
